<ng-container *ngFor="let callout of calloutService.callouts | async">
  <ng-container *ngTemplateOutlet="callout"></ng-container>
</ng-container>
